import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminCompaniesStateData } from "@/types/company"

export type AdminCompaniesState = {
  data: AdminCompaniesStateData
  error: string | null
}

export const adminCompaniesInitialState: AdminCompaniesState = {
  data: {
    companies: [],
    pagination: {
      pageNumber: 1,
      pageSize: 10,
      totalElements: 0,
      totalPages: 0,
    },
  },
  error: null,
}

const slice = createSlice({
  name: "adminCompanies",
  initialState: adminCompaniesInitialState,
  reducers: {
    setAdminCompaniesAction(state, { payload }: PayloadAction<AdminCompaniesStateData>) {
      state.data = payload
      state.error = null
    },
    setAdminCompaniesErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const { setAdminCompaniesAction, setAdminCompaniesErrorAction } = slice.actions
export default slice.reducer
